import { render, staticRenderFns } from "./AddExtraPaymentForm.vue?vue&type=template&id=00327497&scoped=true&"
import script from "./AddExtraPaymentForm.vue?vue&type=script&lang=ts&"
export * from "./AddExtraPaymentForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddExtraPaymentForm.vue?vue&type=style&index=0&id=00327497&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00327497",
  null
  
)

export default component.exports